import type { LunarPaymentDto } from '@lunary/api-client'
import { ApiError } from '../../shared/api/client'
import { ConfirmDialog } from '../../shared/ui/confirm-dialog'
import { formatNumber } from '../../shared/ui/charts/scale'
import { useRefundPayment } from './queries'

export function RefundDialog({ payment, onClose }: { payment: LunarPaymentDto | null; onClose: () => void }) {
  const refund = useRefundPayment()
  const close = () => {
    refund.reset()
    onClose()
  }
  const error = refund.error ? (refund.error instanceof ApiError ? refund.error.message : 'Не получилось, попробуйте ещё раз') : null

  return (
    <ConfirmDialog
      open={payment !== null}
      title="Вернуть оплату?"
      text={
        payment
          ? `ЮKassa вернёт ${formatNumber(payment.amount)} ₽ на карту покупателя, а с его баланса спишутся ${formatNumber(payment.lunars)} лунаров. Отменить возврат нельзя. Чек по этому платежу затем нужно аннулировать в «Мой налог».`
          : ''
      }
      confirmLabel="Вернуть"
      danger
      pending={refund.isPending}
      error={error}
      onConfirm={() => {
        if (payment) refund.mutate(payment.id, { onSuccess: close })
      }}
      onClose={close}
    />
  )
}
